import { useEffect, useState, useRef } from "react";
import "./chatbox.css";
import { rp } from "framer-motion/client";
import { FaRegFilePdf } from "react-icons/fa6";
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileAlt } from "react-icons/fa";
import { LuSend } from "react-icons/lu";

function Chatbox({
  selectedRowID,
  selectedEmail,
  searchedTicketId,
  status,
  ticketclosed,
  ticketclosedbyname,
  userId,
}) {
  const [isSending, setIsSending] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  // const [newMessage, setNewMessage] = useState("");
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const ticketId = searchedTicketId || selectedRowID;
  const userID = userDetails?.userid || userId;

  const [newmessage, setnewmessage] = useState({
    text: "",
    file: null,
  });
  // Reference to the last message element
  const messagesEndRef = useRef(null);

  const handleSendMessage = async (e) => {
    if (e?.preventDefault) e.preventDefault();

    // Don't send if both file and text are empty
    if (!newmessage?.text && !newmessage?.file) return;
    setIsSending(true);

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/sendmsg.php`;
    const formData = new FormData();

    formData.append("user_id", userDetails?.userid);
    formData.append("tic_id", ticketId);
    formData.append("email", selectedEmail);

    // Prioritize file if present
    if (newmessage.file) {
      formData.append("message", newmessage.file); // actual File object
    } else {
      formData.append("message", newmessage.text);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        fetchMessages();
        setChatMessages((prev) => [
          ...prev,
          {
            user_id: userDetails.userid,
            message: newmessage.file ? newmessage.file.name : newmessage.text,
            created_at: new Date().toISOString(),
          },
        ]);

        // Reset message input
        setnewmessage({
          text: "",
          file: null,
        });
      } else {
        alert(data.message || "An unexpected error occurred.");
        console.error(data);
      }
    } catch (error) {
      console.error("Error during message send:", error);
      alert("Error sending message.");
    } finally {
      setIsSending(false); // Re-enable button after completion
    }
  };

  const fetchMessages = async () => {
    if (!ticketId) return;

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmsg.php`;
    const formData = new FormData();

    formData.append("user_id", userID);
    formData.append("tic_id", ticketId);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        setChatMessages(data);
      } else if (response.ok && Array.isArray(data.data)) {
        setChatMessages(data.data);
      } else {
        console.error(
          "Error fetching messages:",
          data.message || "Invalid response format"
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // const FileIcon = ({ message }) => {
  //   const extension = message?.split(".").pop()?.toLowerCase();

  //   if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
  //     return (
  //       <img src={message} alt="uploaded" className="file-image-preview" />
  //     );
  //   }

  //   return <span className="file-icon">📎</span>;
  // };

  useEffect(() => {
    fetchMessages();
  }, [ticketId]);

  // Scroll to the last message whenever chatMessages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages]);

  return (
    <div className="chat-container">
      <div className="chat-header">
        {userDetails?.role === "user" ? (
          <h3>Update with Support</h3>
        ) : (
          <h3>Update with Client</h3>
        )}
      </div>

      <div className="chat-box">
        <div className="chat-messages">
          {chatMessages.map((message, index) => {
            const isFile =
              message.message?.includes("support.myhrsoft.com/apis/chat") ||
              /\.(pdf|docx?|xlsx?|jpg|jpeg|png|gif|jsx)$/i.test(
                message.message
              );

            const fileUrl = message.message.startsWith("http")
              ? message.message
              : `${process.env.REACT_APP_BASEURL}/apis/chat/${message.message}`;

            return (
              <div key={index}>
                <div
                  className={`chat-message ${
                    message.user_id === userDetails.userid
                      ? "chat-message client"
                      : "chat-message employee"
                  }`}
                >
                  <span className="sender-name">
                    {message.user_id === userDetails.userid
                      ? "You"
                      : message.role === "imanager"
                      ? "IT Manager"
                      : null || message.role === "admin"
                      ? "Admin"
                      : null || message.role === "support"
                      ? "Support"
                      : null || message.role === "icoordinator"
                      ? "IT Co-ordinator"
                      : null}
                  </span>

                  {/* ... rest of your message rendering */}

                  {isFile ? (
                    <div className="chat-file">
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* Show icon depending on file type */}
                        {/\.(pdf)$/i.test(fileUrl) && (
                          <FaFilePdf size={20} color="#d32f2f" />
                        )}
                        {/\.(docx?)$/i.test(fileUrl) && (
                          <FaFileWord size={20} color="#1a73e8" />
                        )}
                        {/\.(xlsx?)$/i.test(fileUrl) && (
                          <FaFileExcel size={20} color="#2e7d32" />
                        )}
                        {/\.(jsx?)$/i.test(fileUrl) && (
                          <FaFileAlt size={20} color="#2e7d32" />
                        )}
                        {/\.(jpg|jpeg|png|gif)$/i.test(fileUrl) ? (
                          <img
                            src={fileUrl}
                            alt="uploaded file"
                            className="chat-image-preview"
                            // <FaFileAlt size={20} color="#555" />
                          />
                        ) : (
                          <span className="chat-file-name">
                            {fileUrl.split("/").pop()}
                          </span>
                        )}
                      </a>
                    </div>
                  ) : (
                    <div>{message.message}</div>
                  )}
                </div>
                <span
                  className={`chat-timestamp ${
                    message.user_id === userDetails.userid
                      ? "chat-time stime"
                      : "chat-time rtime"
                  }`}
                >
                  {message.created_at}
                </span>
              </div>
            );
          })}
          <div ref={messagesEndRef} />
        </div>
      </div>

      {status === "Closed" ? (
        <div className="closebn">
          <p>
            This ticket was Closed on <strong>{ticketclosed}</strong> by{" "}
            <strong>{ticketclosedbyname}</strong>
          </p>
        </div>
      ) : (
        <form className="chat-input" onSubmit={handleSendMessage}>
          {/* File Upload Trigger with + Icon */}
          <label
            // htmlFor="file-upload"
            className={`file-upload-label ${isSending ? "blurred" : ""}`}
          >
            +
          </label>
          <input
            id="file-upload"
            type="file"
            style={{ display: "none" }}
            onChange={(e) =>
              setnewmessage((pv) => ({
                ...pv,
                file: e.target.files[0],
                text: "",
              }))
            }
          />

          {/* Conditionally show text input or file name */}
          {newmessage?.file ? (
            <div className={`file-preview ${isSending ? "blurred" : ""}`}>
              <span className="file-name">{newmessage.file.name}</span>
              <div
                type="button"
                className="remove-file-btn"
                onClick={() =>
                  setnewmessage((pv) => ({
                    ...pv,
                    file: null,
                  }))
                }
              >
                ✕
              </div>
            </div>
          ) : (
            <input
              className={`chatin ${isSending ? "blurred" : ""}`}
              type="text"
              placeholder="Type a message..."
              value={newmessage?.text || ""}
              onChange={(e) =>
                setnewmessage((pv) => ({
                  ...pv,
                  text: e.target.value,
                }))
              }
              disabled={isSending} // Also disable typing while sending
              required
            />
          )}

          <button
            className={`sendbn ${isSending ? "blurred" : ""}`}
            type="submit"
            onClick={handleSendMessage}
            disabled={isSending}
          >
            <div className="svg-wrapper-1">
              <div className="svg-wrapper">
                <LuSend />
              </div>
            </div>
            <span>{isSending ? "Sending..." : "Send"}</span>
          </button>
        </form>
      )}
    </div>
  );
}

export default Chatbox;
